"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const core_1 = require("@material-ui/core");
const TGLabelWrapperWeb_1 = __importDefault(require("./TGLabelWrapperWeb"));
const CommonRootWeb_1 = require("./CommonRootWeb");
// Did it this way
// but could just do
// interface TextInputProps { miniIcon:string;}
// to extends react props
const TGTextFieldRootWeb = props => {
    const { readOnly, warning, computed } = props;
    const classes = CommonRootWeb_1.useStyles();
    const [tooltip, setTooltip] = react_1.useState(false);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TGLabelWrapperWeb_1.default, { required: props.required, readOnly: readOnly, label: props.label, info: props.info, tooltip: tooltip, calculated: computed, error: props.error }),
        react_1.default.createElement(core_1.TextField, { fullWidth: true, InputLabelProps: {
                shrink: true,
                className: clsx_1.default(classes.labelShrink, warning && classes.warningText),
            }, className: clsx_1.default(classes.formElementWrapper, classes.customBorderColor), variant: "outlined", error: props.error, value: props.value, onChange: props.onChange, onFocus: props.onFocus, placeholder: props.placeholder, InputProps: {
                readOnly,
                disabled: readOnly,
                className: clsx_1.default(warning && classes.warningBorderBottom),
            }, FormHelperTextProps: { className: clsx_1.default(warning && classes.warningText) }, required: false, 
            // We want the Tooltip to be triggered on field hovering, but positionned relative to the label
            onMouseEnter: () => readOnly && setTooltip(true), onMouseLeave: () => readOnly && setTooltip(false) }),
        !!props.helperText && (react_1.default.createElement(core_1.FormHelperText, { className: clsx_1.default(warning && classes.warningText, classes.errorText) }, props.helperText))));
};
exports.default = TGTextFieldRootWeb;
//# sourceMappingURL=TGTextFieldRootWeb.js.map